import type { DocMigration } from "../docMigration";

// The load plan label is now its own ELECTRIC_LOAD_LABEL category, so view templates (what renders)
// and SCALING effects (what resizes) that named ELECTRICAL_LOADS must name it too or lose the label.
const migration: DocMigration = {
  id: "20260811_add_electric_load_label",
  description:
    "Backfill ELECTRIC_LOAD_LABEL onto view templates and SCALING effects that already name ELECTRICAL_LOADS",
  apply(json: any) {
    function backfillElectricLoadLabel(categories: unknown): void {
      // An empty array already means "every category", so adding an entry would narrow it.
      if (!Array.isArray(categories) || categories.length === 0) {
        return;
      }

      if (categories.indexOf("ELECTRICAL_LOADS") >= 0 && categories.indexOf("ELECTRIC_LOAD_LABEL") < 0) {
        categories.push("ELECTRIC_LOAD_LABEL");
      }
    }

    for (const id in json.viewTemplates ?? {}) {
      backfillElectricLoadLabel(json.viewTemplates[id]?.categories);
    }

    for (const id in json.effects ?? {}) {
      const effect = json.effects[id];
      if (effect?.type === "SCALING") {
        backfillElectricLoadLabel(effect.categories);
      }
    }

    return json;
  },
};

export default migration;
